/**
 * @file 常量文件
 * @description 定义类型列表，如协议类型、产品类型、映射类型、数据类型等。多用于下拉选择
 */

/**
 * @property {Object} TypeList
 * @property {string} label - 标签值
 * @property {string} value - 对应数据字段
 */

// 通讯协议类型列表
export const protocolTypeList = [
  {
    label: 'modbus',
    value: '0'
  },
  {
    label: '645',
    value: '1'
  }
]
// 产品类型列表
export const deviceTypeList = [
  {
    label: '微断',
    value: '0'
  },
  {
    label: '塑壳',
    value: '1'
  },
  {
    label: '框架',
    value: '2'
  },
  {
    label: '双电源',
    value: '3'
  }
]
// 映射类型列表
export const mappingTypeList = [
  {
    label: '值映射',
    value: 0
  },
  {
    label: 'bit位映射',
    value: 1
  }
]
// 数据类型列表
export const dataTypeList = [
  {
    label: '无符号数',
    value: '1'
  },
  {
    label: '有符号数',
    value: '1'
  },
  {
    label: '二进制',
    value: '2'
  },
  {
    label: 'BCD码',
    value: '3'
  },
  {
    label: 'ASCII码',
    value: '4'
  }
]
// 测试操作类型列表
export const testOperationTypeList = [
  {
    label: '三相涵普源',
    value: '0'
  },
  {
    label: '信号发生器',
    value: '1'
  },
  {
    label: '计时',
    value: '2'
  },
  {
    label: '写数据',
    value: '3'
  },
  {
    label: '读数据对比',
    value: '4'
  }
]

// 时间单位
export const timeUnitList = [
  {
    label: '分(m)',
    value: '0'
  },
  {
    label: '秒(s)',
    value: '1'
  },
  {
    label: '毫秒(ms)',
    value: '2'
  }
]
// 比较类型
export const compareTypeList = [
  {
    label: '等于(=)',
    value: '0'
  },
  {
    label: '不等于(!=)',
    value: '1'
  },
  {
    label: '范围(~)',
    value: '2'
  },
  {
    label: '大于(>)',
    value: '3'
  },
  {
    label: '小于(<)',
    value: '4'
  },
  {
    label: '大于等于(>=)',
    value: '5'
  },
  {
    label: '小于等于(<=)',
    value: '6'
  }
]
// 可配置端口设备类型
export const serialTypeList = [
  // {
  //   label: '被测设备',
  //   value: '0'
  // },
  // {
  //   label: '三相涵普源',
  //   value: '1'
  // },
  // {
  //   label: '信号发生器1',
  //   value: '2'
  // },
  // {
  //   label: '信号发生器2',
  //   value: '3'
  // }
]
// 相别类型(不含N相)
export const phaseTypeList = [
  {
    label: 'A相',
    value: '0'
  },
  {
    label: 'B相',
    value: '1'
  },
  {
    label: 'C相',
    value: '2'
  }
]
// 相别类型(含N相)
export const phaseTypeListN = [
  {
    label: 'A相',
    value: '0'
  },
  {
    label: 'B相',
    value: '1'
  },
  {
    label: 'C相',
    value: '2'
  },
  {
    label: 'N相',
    value: '3'
  }
]
// 波形类型
export const waveTypeList = [
  {
    label: '正弦波',
    value: '0'
  },
  {
    label: '方波',
    value: '1'
  },
  {
    label: '三角波',
    value: '2'
  }
]
